/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import React from "react";

import { INavigationLinkProps } from "Components/NavigationLink/INavigationLinkProps";
import NavigationLink from "Components/NavigationLink/NavigationLink";

import PrivacyIcon from "../../Assets/Icons/Privacy.svg";
import { ISideNavigationProps } from "./ISideNavigationProps";
import { FlexColumn, NavigationContainer } from "./SideNavigation.styles";

const SideNavigation = ({ links }: ISideNavigationProps): React.ReactElement => {
  const privacyLink: INavigationLinkProps = {
    isPrivacyLink: true,
    icon: PrivacyIcon,
    source: "https://go.microsoft.com/fwlink/?LinkId=518021",
    tenant: "MSP",
    text: "Privacy Notice",
  };

  return (
    <NavigationContainer>
      <FlexColumn>
        {links.map((link, index) => (
          <NavigationLink key={index} {...link} />
        ))}
      </FlexColumn>
      <FlexColumn>
        <NavigationLink {...privacyLink} />
      </FlexColumn>
    </NavigationContainer>
  );
};

export default SideNavigation;
